import Cookies from 'js-cookie';
import { formatStorePrice as _formatStorePrice } from '../../utils/ecommerce/currency.js';
import { getRootDomain } from '../../utils/common/url.js';
/**************
 *
 * Polifills
 */

// https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
if (!Element.prototype.matches) {
	Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
	Element.prototype.closest = function (s) {
		var el = this;

		do {
			if (el.matches(s)) return el;
			el = el.parentElement || el.parentNode;
		} while (el !== null && el.nodeType === 1);
		return null;
	};
}

/**************
 *
 *  ** end of Polifills
 */

class ppUtilities {
	constructor() {
		this.hasParentTabs = false;
		this.tabParent = null;
		this.tabsActions = [];
		this.cardAnimation = 'customfadeInUp';
	}

	//function customized from: https://codepen.io/w3resource/pen/dKzNRy
	static create_UUID() {
    const array = new Uint8Array(16);
    window.crypto.getRandomValues(array);

    let dt = new Date().getTime();
    let uuid = 'xxxxxxxx'.replace(/[xy]/g, function (c, i) {
        const r = (dt + array[i]) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
  }

	static async getCountryCode() {
		let countryCode = '';

		if (typeof geoip2 !== 'undefined') {
			await callInsights();
		} else {
			await constructGeoip();
		}

		async function callInsights() {
			return await new Promise((resolve) => {
				geoip2.insights((insight) => {
					countryCode = insight.country.iso_code;
					resolve();
				});
				// if no response is available from geiop2
				if (countryCode == '') {
					setTimeout(function () {
						if (countryCode == '') {
							if (location.host.indexOf(':4502') > -1) {
								countryCode = 'US';
								resolve();
							} else {
								console.error('ERROR: [geoip2 is not responding]');
								constructGeoip();
								resolve();
							}
						}
					}, 2200); // geoip2 times out at 2000;
				}
			});
		}

		async function constructGeoip() {
			return await new Promise((resolve) => {
				console.info('no geoip2 Object present!!!');
				let _body = document.querySelector('body');
				let newScript = document.createElement('script');
				newScript.src = '//js.maxmind.com/js/apis/geoip2/v2.1/geoip2.js';
				newScript.type = 'text/javascript';
				_body.appendChild(newScript);
				newScript.onload = function () {
					if (typeof geoip2 !== 'undefined') {
						geoip2.insights((insight) => {
							console.info('[from maxMind]: ', insight);
							countryCode = insight.country.iso_code;
							resolve();
						});
					}
				};
			});
		}

		function getCookieDomain() {
			let cookieDom = '';
			try {
				cookieDom = getRootDomain(location.host);
			} catch (e) {
				console.error(`[Cookie domain issue: ${e}`);
			}
			return cookieDom; // Cookie if issue do not set let browser to set default
		}

		function setCookieCart(_countryCode) {
			let domain = getCookieDomain();
			Cookies.set('omniCoutryCode', _countryCode, { expires: 2000, path: '/', domain });
		}

		setCookieCart(countryCode);
	}

	static scrollAnimteLinks(links) {
		links.forEach((link) => {
			jQuery(link).click((event) => {
				event.preventDefault();
				let $target = jQuery(event.target.hash);
				jQuery('html, body').animate(
					{
						scrollTop: $target.offset().top,
					},
					600,
					function () {
						// will add callbacks if needed;
					}
				);
			});
		});
	}

	static getCookie(cookieName) {
		return Cookies.get(cookieName);
	}

	handleCardsAnimation(app) {
		let productCollection = [].slice.call(app.querySelectorAll('.card'));
		let currIndx = 0;
		let intervalAnimation = null;
		let cardAnimation = this.cardAnimation;
		function animateInterval() {
			intervalAnimation = setInterval(() => {
				stepAnimate();
			}, 200);
		}
		function stepAnimate() {
			productCollection[currIndx].classList.add(cardAnimation);
			productCollection[currIndx].classList.add('animated');
			if (currIndx == productCollection.length - 1) {
				clearInterval(intervalAnimation);
			} else {
				currIndx += 1;
			}
		}

		if (productCollection.length) {
			animateInterval();
			// setTimeout(() => {animateInterval()}, 18000);
		}
	}

	checkWithinTabSys(app) {
		if (app.closest('.tabs')) {
			this.hasParentTabs = true;
			this.tabParent = app.closest('.tabs');
		}
	}

	isWithinTabsSys() {
		return this.hasParentTabs;
	}

	tabListener() {
		let allTabs = [].slice.call(this.tabParent.querySelectorAll('[role="tab"]'));
		if (allTabs.length > 0) {
			allTabs.forEach((tab) => {
				tab.addEventListener('click', () => {
					let activeTab = document.querySelector('.cmp-tabs__tabpanel--active');
					this.handleCardsAnimation(activeTab);
					this.removeAnimationClasses();
				});
			});
		}
	}

	removeAnimationClasses() {
		let currAnimation = this.cardAnimation;
		let cards = [].slice.call(document.querySelectorAll('.cmp-tabs__tabpanel[aria-hidden="true"] .animated'));
		cards.forEach((card) => {
			card.classList.remove(currAnimation, 'animated');
		});
	}

	handleDomCalls(app, prodPricing) {
		let callTriggers = [].slice.call(app.querySelectorAll('[data-click]'));
		if (callTriggers && callTriggers.length) {
			callTriggers.forEach((trigger) => {
				trigger.addEventListener('click', (e) => {
					e.stopPropagation();
					let target = e.target;
					let card = target.closest('.prc__card');
					let cardId = card.getAttribute('data-cardid');
					let callBack = target.getAttribute('data-click');
					prodPricing[callBack](cardId, target);
				});
			});
		}

		let changeTriggers = [].slice.call(app.querySelectorAll('[data-change]'));
		if (changeTriggers && changeTriggers.length) {
			changeTriggers.forEach((trigger) => {
				trigger.addEventListener('change', (e) => {
					let target = e.target;
					let card = target.closest('.prc__card');
					let cardId = card.getAttribute('data-cardid');
					let callBack = target.getAttribute('data-change');
					prodPricing[callBack](cardId, target);
				});
			});
		}
	}

	formatStorePrice(price, formattedLocale, currency) {
		return _formatStorePrice(price, formattedLocale, currency);
	}

	static removeCompareQuery(compareQuery) {
		let compareRegex = /(&|\?)compare=(\d*\,?)+/gi;
		return compareQuery.replace(compareRegex, '');
	}

	static getURLCompareKeys(query) {
		let compareRegex = /(&|\?)compare=(\d*\,?)+/gi;
		let queryRegex = compareRegex.exec(query)[0];
		let skusRegex = /(\d+)/g;
		let skusArr = queryRegex.match(skusRegex);
		return skusArr;
	}

	static anchorTagsToNewTab(parentTarget) {
		let containers = [].slice.call(document.querySelectorAll(parentTarget));

		containers.forEach((container) => {
			let anchors = [].slice.call(container.querySelectorAll('a'));
			anchors.forEach((anchor) => {
				anchor.setAttribute('target', '_blank');
			});
		});
	}
	// external
	static jsCookie() {
		/**
		 * Minified by jsDelivr using UglifyJS v3.4.4.
		 * Original file: /npm/js-cookie@2.2.0/src/js.cookie.js
		 *
		 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
		 */
		!(function (e) {
			var n = !1;
			if (('function' == typeof define && define.amd && (define(e), (n = !0)), 'object' == typeof exports && ((module.exports = e()), (n = !0)), !n)) {
				var o = window.Cookies,
					t = (window.Cookies = e());
				t.noConflict = function () {
					return (window.Cookies = o), t;
				};
			}
		})(function () {
			function g() {
				for (var e = 0, n = {}; e < arguments.length; e++) {
					var o = arguments[e];
					for (var t in o) n[t] = o[t];
				}
				return n;
			}
			return (function e(l) {
				function C(e, n, o) {
					var t;
					if ('undefined' != typeof document) {
						if (1 < arguments.length) {
							if ('number' == typeof (o = g({ path: '/' }, C.defaults, o)).expires) {
								var r = new Date();
								r.setMilliseconds(r.getMilliseconds() + 864e5 * o.expires), (o.expires = r);
							}
							o.expires = o.expires ? o.expires.toUTCString() : '';
							try {
								(t = JSON.stringify(n)), /^[\{\[]/.test(t) && (n = t);
							} catch (e) {}
							(n = l.write
								? l.write(n, e)
								: encodeURIComponent(String(n)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent)),
								(e = (e = (e = encodeURIComponent(String(e))).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)).replace(
									/[\(\)]/g,
									escape
								));
							var i = '';
							for (var c in o) o[c] && ((i += '; ' + c), !0 !== o[c] && (i += '=' + o[c]));
							return (document.cookie = e + '=' + n + i);
						}
						e || (t = {});
						for (var a = document.cookie ? document.cookie.split('; ') : [], s = /(%[0-9A-Z]{2})+/g, f = 0; f < a.length; f++) {
							var p = a[f].split('='),
								d = p.slice(1).join('=');
							this.json || '"' !== d.charAt(0) || (d = d.slice(1, -1));
							try {
								var u = p[0].replace(s, decodeURIComponent);
								if (((d = l.read ? l.read(d, u) : l(d, u) || d.replace(s, decodeURIComponent)), this.json))
									try {
										d = JSON.parse(d);
									} catch (e) {}
								if (e === u) {
									t = d;
									break;
								}
								e || (t[u] = d);
							} catch (e) {}
						}
						return t;
					}
				}
				return (
					((C.set = C).get = function (e) {
						return C.call(C, e);
					}),
					(C.getJSON = function () {
						return C.apply({ json: !0 }, [].slice.call(arguments));
					}),
					(C.defaults = {}),
					(C.remove = function (e, n) {
						C(e, '', g(n, { expires: -1 }));
					}),
					(C.withConverter = e),
					C
				);
			})(function () {});
		});
		//# sourceMappingURL=/sm/31d5cd1b58ce5e6231e4ea03a69b2801a53e76e98152bc29dc82a494ed0a1ee6.map
	}
}

export default ppUtilities;
